import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";

// SCRUM-922: looping Lottie for the seasonal Sign-in decorations (falling
// leaves, floating ghost). Files are served from /public and fetched lazily
// by lottie-web, like HeroTree, so they stay out of the JS bundle and only
// load while a seasonal theme is on. (The spiders use HangingSpider, which
// adds rests between swings.)
export const SPIDER_PATH = "/assets/animations/hanging-spider.json"; // 240x480, thread at top centre
export const LEAVES_PATH = "/assets/animations/autumn-leaves-falling.json"; // 1440x900
export const GHOST_PATH = "/assets/animations/ghost-float.json"; // 950x950, faces left
// SCRUM-933 (Thanksgiving), from Downloads/*.lottie:
// "Happy Thanksgiving Day", 1080x1080, 13s loop: lid opens, turkey peeks, lid
// closes (8s), then the closed pumpkin rests for 5s before it starts again.
export const TURKEY_POT_PATH = "/assets/animations/turkey-in-pumpkin.json";
export const WALKING_TURKEY_PATH = "/assets/animations/walking-turkey.json"; // 1080x1080, faces right, walks in place

const SeasonalLottie = ({ path, className, fit = "xMidYMid meet" }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    // Unlike the brand hero tree (SCRUM-127), these are seasonal extras, so
    // they honour the OS "reduce motion" setting: shown, but held still.
    const reduceMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const anim = lottie.loadAnimation({
      container,
      renderer: "svg",
      loop: true,
      autoplay: !reduceMotion,
      path,
      rendererSettings: { preserveAspectRatio: fit },
    });

    // Purely decorative: if the asset fails to load, render nothing.
    const onFail = () => anim.destroy();
    anim.addEventListener("data_failed", onFail);

    return () => {
      anim.removeEventListener("data_failed", onFail);
      anim.destroy();
    };
  }, [path, fit]);

  return <div ref={containerRef} className={className} aria-hidden="true" />;
};

export default SeasonalLottie;
